import { render, staticRenderFns } from "./DichiarazioniFSC.vue?vue&type=template&id=4ba52100"
import script from "./DichiarazioniFSC.vue?vue&type=script&lang=js"
export * from "./DichiarazioniFSC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports